import React from "react";
import Chapters from "../chapters";

const QuestionsWallet = () => {
  return <Chapters activeFilter={0} title="حافظة الاسئلة" />;
};

export default QuestionsWallet;
